var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTemplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor",
    className: "st0",
    d: "M353.5,386.7c-1.8-1-4.2-1.1-6.2-0.4c-2.9,1-5.1,3.5-6.6,6.2c-1.5,2.7-2.4,5.7-3.6,8.5 c-2.3,5.7-5.4,11-9.3,15.7c-0.8,0.9-1.6,1.9-2.8,2.1c-1.5,0.3-3-0.8-4.1-1.9c-6.8-6.2-12.4-13.5-16.7-21.6c-1.3-2.4-2.5-5-4.6-6.8 c-3.2-2.7-8.3-2.9-11.6-0.5c-2.6,1.9-4.1,5-5.8,7.8c-4.1,6.8-10,12.6-17.2,15.9c-4.3,2-14.8,7.6-6.5,12.6c2.2,1.3,4.9,1.4,7.4,1.1 c7.3-1,13.7-5.6,19.2-10.6c2.1-1.9,4.4-3.9,7.1-4c3.5-0.1,6.2,3.1,8.3,6c5.4,7.2,12,14.8,20.9,15.9c5.1,0.6,10.3-1.1,14.6-3.9 s7.7-6.9,10.5-11.1c4.1-6.1,7.3-12.9,9.3-20c0.9-3,1.5-6.5-0.3-9.1C355.1,387.7,354.3,387.1,353.5,386.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 147.4,
    y: 231.2,
    className: "st0",
    width: 217.1,
    height: 20.4,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.4,
    y: 279.8,
    className: "st0",
    width: 217.1,
    height: 20.4,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.4,
    y: 328.4,
    className: "st0",
    width: 108.6,
    height: 20.4,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor",
    className: "st1",
    d: "M315.9,9.9L311.3,6h-230c-12.1,0-21.9,9.8-21.9,21.9v456.2c0,12.1,9.8,21.9,21.9,21.9h349.3 c12.1,0,21.9-9.8,21.9-21.9V140.8L315.9,9.9z M412.2,469.2H99.8V42.8h182.5V142c0,13.3,10.8,24.1,24.1,24.1h105.8V469.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplate);
export default __webpack_public_path__ + "static/media/icon-template.b6001b724b57a45d13e19d1707b3f392.svg";
export { ForwardRef as ReactComponent };